import React from 'react';
import './SimpleModal.css';

const SimpleModal = ({ isOpen, onClose, title, children, requestedSizing = "", className = "" }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={'modal-backdrop ' + className} onClick={handleBackdropClick}>
            <div className={`modal-content ${requestedSizing}`}>
                <div className="modal-header">
                    <h2>{title}</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SimpleModal;
